import React, { useState, useEffect } from "react";
import { DownloadSimple, X, ShareNetwork, DotsThreeVertical } from "@phosphor-icons/react";

let deferredPrompt = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
  });
}

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent);

export const InstallAppButton = ({ lang, variant = "dark" }) => {
  const cs = lang === "cs";
  const [hidden, setHidden] = useState(false);
  const [guide, setGuide] = useState(false);
  useEffect(() => {
    if (isStandalone()) setHidden(true);
  }, []);
  if (hidden) return null;

  const onClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === "accepted") {
        deferredPrompt = null;
        setHidden(true);
      }
      return;
    }
    setGuide(true);
  };

  const cls = variant === "gold"
    ? "border border-zinc-800 hover:border-amber-500/50 hover:bg-zinc-900 text-zinc-200 font-medium px-6 py-3 rounded-md transition-all flex items-center gap-2"
    : "flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium bg-zinc-900 hover:bg-zinc-800 border border-zinc-800 text-zinc-200 transition-colors";

  return (
    <>
      <button onClick={onClick} data-testid="install-app-btn" className={cls}>
        <DownloadSimple weight="bold" size={variant === "gold" ? 18 : 16} />
        {cs ? "Stáhnout aplikaci" : "Install app"}
      </button>
      {guide && (
        <div className="fixed inset-0 z-[70] bg-zinc-950/85 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setGuide(false)} data-testid="install-guide-modal">
          <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 max-w-sm w-full relative" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setGuide(false)} data-testid="install-guide-close" className="absolute top-3 right-3 text-zinc-500 hover:text-zinc-200 transition-colors">
              <X weight="bold" size={18} />
            </button>
            <div className="text-lg font-semibold text-zinc-100 mb-3">
              {cs ? "Instalace aplikace" : "Install the app"}
            </div>
            {isIOS() ? (
              <ol className="text-sm text-zinc-400 space-y-2.5 list-decimal list-inside leading-relaxed">
                <li>{cs ? <>Klepni na tlačítko <strong className="text-zinc-200">Sdílet</strong> <ShareNetwork className="inline" size={14} /> v liště Safari</> : <>Tap the <strong className="text-zinc-200">Share</strong> <ShareNetwork className="inline" size={14} /> button in Safari</>}</li>
                <li>{cs ? <>Vyber <strong className="text-zinc-200">Přidat na plochu</strong></> : <>Choose <strong className="text-zinc-200">Add to Home Screen</strong></>}</li>
                <li>{cs ? <>Potvrď <strong className="text-zinc-200">Přidat</strong> — ikona TradeMind AI se objeví na ploše</> : <>Confirm <strong className="text-zinc-200">Add</strong> — the TradeMind AI icon appears on your home screen</>}</li>
              </ol>
            ) : (
              <ol className="text-sm text-zinc-400 space-y-2.5 list-decimal list-inside leading-relaxed">
                <li>{cs ? <>Otevři menu prohlížeče <DotsThreeVertical className="inline" size={14} /> (tři tečky vpravo nahoře)</> : <>Open the browser menu <DotsThreeVertical className="inline" size={14} /> (three dots, top right)</>}</li>
                <li>{cs ? <>Vyber <strong className="text-zinc-200">Nainstalovat aplikaci</strong> nebo <strong className="text-zinc-200">Přidat na plochu</strong></> : <>Choose <strong className="text-zinc-200">Install app</strong> or <strong className="text-zinc-200">Add to Home screen</strong></>}</li>
                <li>{cs ? "Potvrď — TradeMind AI se nainstaluje jako aplikace" : "Confirm — TradeMind AI installs as an app"}</li>
              </ol>
            )}
          </div>
        </div>
      )}
    </>
  );
};
